import React from "react";
import {Helmet} from "react-helmet-async";

const TimelinePage = () => (
    <>
        <Helmet>
            <title>Tidslinje</title>
        </Helmet>
        <div>
            <h1>Tidslinje</h1>
            <p>Innehåll kommer visas här</p>
        </div>
    </>
);

export default TimelinePage;
